import { PrizetAttributeSelector } from '../../components/PrizetAttributeSelector';
import { componentMapper } from '@data-driven-forms/mui-component-mapper';
import { ProductVariantSelector, TagFieldProvider } from '../providers/field-providers.ts';
import { PrizetS3UploadFieldProvider } from '../providers/PrizetS3UploadFieldProvider';

export const PrizeetMappers = {
  's3': PrizetS3UploadFieldProvider,
  'selector': PrizetAttributeSelector,
  'tags': TagFieldProvider,
  'product-selector': ProductVariantSelector,
  ...componentMapper


}
